import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import * as ServiceActions from './service.actions';
import { of } from 'rxjs';
import { SiteService } from 'src/app/services/site.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { Notification, NotificationLevel } from 'src/app/model/notification';
import { AppState } from '../app.reducer';
import { Store } from '@ngrx/store';
import * as NotificationsActions from '../notifications/notifications.actions';

@Injectable()
export class ServiceEffects {

    checkKeycode$ = createEffect(() => this.actions$.pipe(
        ofType(ServiceActions.checkKeycode),
        switchMap((action) => this.siteService.checkKeycode(action.term).pipe(
            map((resp) => {
                if (resp.Success) {
                    return ServiceActions.checkKeycodeSuccess({ checkResult: resp.Data });
                }
                else {
                    return ServiceActions.checkKeycodeFailed({ errorMessage: this.translate.instant('SEARCH_FAILED') });
                }
            }),
            catchError(error => {
                console.error(error);
                return of(ServiceActions.checkKeycodeFailed({ errorMessage: this.translate.instant('AUTH_ERROR') }));
            })
        ))
    ));

    checkPeople$ = createEffect(() => this.actions$.pipe(
        ofType(ServiceActions.checkPeople),
        switchMap((action) => this.userService.checkPeople(action.email).pipe(
            map((resp) => {
                if (resp.Success) {
                    return ServiceActions.checkPeopleSuccess({ checkResult: resp.Data });
                }
                else {
                    return ServiceActions.checkPeopleFailed({ errorMessage: this.translate.instant('SEARCH_FAILED') });
                }
            }),
            catchError(error => {
                console.error(error);
                return of(ServiceActions.checkPeopleFailed({ errorMessage: this.translate.instant('AUTH_ERROR') }));
            })
        ))
    ));

    searchEmail$ = createEffect(() => this.actions$.pipe(
        ofType(ServiceActions.searchEmail),
        switchMap((action) => this.userService.searchEmail(action.term).pipe(
            map((resp) => {
                if (resp.Success) {
                    return ServiceActions.searchEmailSuccess({ emailOptions: resp.Data });
                }
                else {
                    return ServiceActions.searchEmailFailed({ errorMessage: this.translate.instant('SEARCH_FAILED') });
                }
            }),
            catchError(error => {
                console.error(error);
                return of(ServiceActions.searchEmailFailed({ errorMessage: this.translate.instant('AUTH_ERROR') }));
            })
        ))
    ));


    deleteKeycode$ = createEffect(() => this.actions$.pipe(
        ofType(ServiceActions.deleteKeycode),
        switchMap((action) => this.userService.deleteKeycode(action.keycode)
            .pipe(
                map(resp => {
                    if (resp.Success) {
                        return ServiceActions.deleteKeycodeSuccess({ message: this.translate.instant('SERVICE_DELETE_KEYCODE_SUCCESS') });
                    } else {
                        return ServiceActions.deleteKeycodeFailed({ errorMessage: this.translate.instant('SERVICE_DELETE_KEYCODE_ERROR') });
                    }
                }),
                catchError(() => of(ServiceActions.deleteKeycodeFailed({ errorMessage: this.translate.instant('SERVICE_DELETE_KEYCODE_ERROR') })))
            )
        )
    ));

    deleteUser$ = createEffect(() => this.actions$.pipe(
        ofType(ServiceActions.deleteUser),
        switchMap((action) => this.userService.deleteUser(action.userId)
            .pipe(
                map(resp => {
                    if (resp.Success) {
                        return ServiceActions.deleteUserSuccess({ message: this.translate.instant('SERVICE_DELETE_USER_SUCCESS') });
                    } else {
                        return ServiceActions.deleteUserFailed({ errorMessage: this.translate.instant('SERVICE_DELETE_USER_ERROR') });
                    }
                }),
                catchError(() => of(ServiceActions.deleteUserFailed({ errorMessage: this.translate.instant('SERVICE_DELETE_USER_ERROR') })))
            )
        )
    ));


    notifyError$ = createEffect(() => this.actions$.pipe(
        ofType(
            ServiceActions.searchEmailFailed,
            ServiceActions.checkKeycodeFailed,
            ServiceActions.checkPeopleFailed,
            ServiceActions.deleteKeycodeFailed,
            ServiceActions.deleteUserFailed,
        ),
        tap((action) => {
            if (action.errorMessage === '') {
                return;
            }
            const notification = new Notification("SERVICE", action.errorMessage, NotificationLevel.Error, '');
            this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
        })
    ), { dispatch: false });

    notifySuccess$ = createEffect(() => this.actions$.pipe(
        ofType(
            ServiceActions.deleteKeycodeSuccess,
            ServiceActions.deleteUserSuccess,
        ),
        tap((action) => {
            if (action.message === '') {
                return;
            }
            const notification = new Notification("SERVICE", action.message, NotificationLevel.Success, '');
            this.store.dispatch(NotificationsActions.addNotification({ notification: notification, toastOnly: true }));
        })
    ), { dispatch: false });


    constructor(
        private actions$: Actions,
        private translate: TranslateService,
        private siteService: SiteService,
        private userService: UserService,
        private store: Store<AppState>,
    ) { }
}
